import { FlowioThunkCreator } from "../../types";

import * as AC from "../actionCreators";
import * as S from "../selectors";
import * as R from "../../../requests/globalRequests/requestCreators";
import {
  fetchFavouriteTemplatesError,
  fetchFavouriteTemplatesRequest,
  fetchFavouriteTemplatesSuccess,
} from "../../favouriteTemplates/actions";
import { FetchStatus } from "../../../globalConsts";

type ThunkCreator = FlowioThunkCreator<void>;

export const fetchHomepagePartition: ThunkCreator =
  () => (dispatch, getState) =>
    Promise.resolve().then(async () => {
      const status = S.getStatusForGlobalFetchPartition(getState(), "homepage");
      if (status !== FetchStatus.Uninitialized) return;

      dispatch(AC.requestFetchGlobalPartition({ partition: "homepage" }));
      dispatch(fetchFavouriteTemplatesRequest());

      try {
        const { data } = await R.fetchHomepagePartition();

        dispatch(fetchFavouriteTemplatesSuccess(data.userFavouriteTemplates));
        dispatch(AC.receiveFetchGlobalPartition({ partition: "homepage" }));
      } catch (e) {
        dispatch(AC.errorFetchGlobalPartition({ partition: "homepage" }));
        dispatch(fetchFavouriteTemplatesError());
      }
    });

export type FetchHomepagePartition = ThunkCreator;
